module.exports = __webpack_public_path__ + "static/media/thumb_photo.3ab12651.svg";